import styled from '@emotion/styled';

import colors from 'config/theme/colors';

export const StyledReference = styled.span`
  color: ${colors['@primary-color']};
  font-weight: bold;
`;
